import { Select } from "antd";
import styles from "./styles.module.scss";
import { Option } from "antd/es/mentions";
export function CustomDropDown({ onChangeHandler, value }: any) {
  const timeOptions = [
    "All",
    "1 hr",
    "4 hrs",
    "8 hrs",
    "12 hrs",
    "1 day",
    "3 days",
    "1 week",
  ];

  function handleSelectedValue(value: any) {
    onChangeHandler("timeInterval", value);
  }
  return (
    <div>
      <Select
        style={{ height: 40, width: 150 }}
        defaultValue={timeOptions[0]}
        onChange={handleSelectedValue}
        value={value}
      >
        {timeOptions.map((option: any) => (
          <Option key={option} value={option}>
            {option}
          </Option>
        ))}
      </Select>
    </div>
  );
}
